<template>
  <vue-apex-charts
    class="istBarChart"
    ref="insightChartBar"
    :height="barChartHeight"
    v-on:update:heightSetting="setHeight"
    :options="chartOptionsBar"
    :series="series"
  />
</template>

<script>
import VueApexCharts from "vue-apexcharts";

const colorMap = ["#3366cc", "#dc3912", "#ff9900", "#109618", "#990099", 
                  "#0099c6", "#dd4477", "#66aa00", "#b82e2e", "#316395", 
                  "#994499", "#22aa99", "#aaaa11", "#6633cc", "#e67300", 
                  "#8b0707", "#651067", "#329262", "#5574a6", "#3b3eac"];

export default {
  name: "InsightChartBar",
  components: {
    VueApexCharts,
  },
  data() {
    return {
      barChartHeight: 45*21,
      chartOptionsBar: {
        chart: {
          type: "bar",
          background: '#FBFBFB',
          toolbar:{
            show: false
          },
          sparkline:{
            enabled: true
          },
          events: {
            dataPointSelection: function(event, chartContext, opt) {             
              opt.w.globals.dom.baseEl.__vue__.$store.dispatch('callBrandInsightUpper', { selBrand: opt.w.globals.labels[opt.dataPointIndex] })
            }
          }
        },
        grid:{
          show: true,
        },
        dataLabels: {
          enabled: true,
          fontFamily: "NanumBarunGothic !important",
          textAnchor: 'start',
          style: {
            colors: ['#333'],
          },
          formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ":  " + Math.round(val) + "%"
          },
          offsetX: 0,
          dropShadow: {
            enabled: true
          }
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        tooltip: {
          followCursor: true,
          x: {
            show: true
          },
          y: {
            formatter(val){
              return val
            },
            title: {
              formatter: function () {
                return ''
              }
            },
          },
        },
        legend: {
          show: false,
          position: "top",
          horizontalAlign: "left",
          offsetX: 0,
          fontSize: "12px",
          fontFamily: "NanumBarunGothic !important",
          itemMargin: {
            horizontal: 5,
            vertical: 5,
          },
        },
        plotOptions: {
          bar: {
                barHeight: '80%',
                distributed: true,
                horizontal: true,
                dataLabels: {
                  position: 'bottom'
                },
              }
        },
        noData: {
          text: '분석중...',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#1817E7',
            fontSize: '20px',
            fontFamily: "NanumBarunGothicB"
          }
        },
        colors: [
          function({ value, seriesIndex, w }) {
            if(w.globals.labels[seriesIndex] == 'NONBRANDED')
              return '#bfbfbf';
            else
              return '#A5BFFF';
          }
        ],
      },
      series: [{
        data: []
      }],
    };
  },
  props: {
    barChartData: {
      type: Array,
      default: () => [],
    },
    barChartFreq: {
      type: Array,
      default: () => [],
    },
    barChartCategory: {
      type: Array,
      default: () => [],
    },
    totalFreq: {
      type: Number,
      default: 0
    },
  },
  watch: {
    barChartData() {
      const newData = []
      for (const data of this.barChartData) {
        newData.push(data);
      }
      const newCategory = []
      for (const data of this.barChartCategory) {
        newCategory.push(data);
      }
      const newFreq = []
      for (const data of this.barChartFreq) {
        newFreq.push(data);
      }
      // const barChartOption = {
      //   xaxis: {
      //     categories: newCategory,
      //   },
      //   series: [{
      //     data: newData
      //   }]
      // };

      
      this.setHeight(45*newCategory.length)
      this.setValues(newData, newCategory, this.totalFreq, newFreq)
      
    },
  },

  methods:{
    setHeight(value) {
      this.barChartHeight = value
    },
    setValues(newData, newCategory, totalFreq, newFreq){
      console.log('===================================')
      console.log(newData)
      console.log(newCategory)

      this.chartOptionsBar.xaxis = {
          categories: newCategory,
        }
      this.series = [{
          data: newData
        }]      
      this.chartOptionsBar.tooltip = {
        followCursor: true,
        enabled: true,
        fixed: {
          enabled: false,
        },
        x: {
          show: true
        },
        y: {
          formatter: function(val, opt){
            return Math.round(newFreq[opt.dataPointIndex]).toLocaleString()
          },
          // formatter(val){
          //   return Math.round((val / 100) * totalFreq).toLocaleString()
          // },
          title: {
            formatter: function () {
              return ''
            }
          },
        },
      }

      this.$refs.insightChartBar.updateOptions(this.chartOptionsBar, true);


    }
  }
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/chart-apex.scss";

.istBarChart .apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-title {
  font-size: 12px !important;
  font-weight: 600;
}

.istBarChart .apexcharts-canvas .apexcharts-tooltip-text {
  font-family: NanumBarunGothic !important;
  font-weight: 400;
  font-size: 10px !important;
  filter: none;
}

.istBarChart .apexcharts-tooltip-marker {
  width: 8px;
  height: 8px;
  position: relative;
  top: 0px;
  margin-right: 5px;
  border-radius: 50%;
}
</style>
